module.exports = __webpack_public_path__ + "img/classify_15.e191e8d8.png";